<p>
  agenda-calendario works!
</p>
<!DOCTYPE html>
<html lang="es">

<head>
  <meta charset="utf-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  <meta name="apple-mobile-web-app-capable" content="yes">

  <title>IACPOS</title>

  <meta name="description" content="">

  <link rel="shortcut icon" href="./favicon.ico">

  <!--<link rel="stylesheet" href="./css/main.css">-->
  <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900" rel="stylesheet">
</head>


<body class="body is-Home">


  <header class="header">
  <div class="colors">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="header-content">
<!--     <div class="logo">
      <h1>Museo Nacional <br>del <strong>Prado</strong></h1>
    </div> -->

    <div class="fecha-hora">Domingo 28, Noviembre 2019 - 16:23h</div>
    <div class="user">
      <img class="svg" src="./img/icon-user.svg" alt="icono usuario">
      <div class="name">José Martínez Rodríguez</div>
    </div>
    <div class="icon-section">
      <img class="svg" src="./img/icon-timer.svg" alt="icono timer">
      <div class="text">ABC00</div>
    </div>
    <div class="icon-section">
      <img class="svg" src="./img/icon-shop.svg" alt="icono shop">
      <div class="text">ABC00</div>
    </div>
    <div class="close">
      <a href="/venta/entradas" title="cerrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
    </div>
  </div>
</header>



<div class="main home">


  <form>
    <div class="layout">
      <section class="col-servicios">
        <nav class="nav-serv">
          <ul>
            <li class="current"><a href="#" title="Venta">Venta</a></li>
            <li><a href="#" title="GESTIONAR">GESTIONAR</a></li>
            <li><a href="#" title="DEVOLUCIÓN">DEVOLUCIÓN</a></li>
            <li><a href="#" title="F1">F1</a></li>
            <li><a href="#" title="F2">F2</a></li>
          </ul>
        </nav>
        <a class="CancelButton" href="#" title="Cancelar">Cancelar</a>
      </section>
      <section class="col-seleccion">
        <nav class="venta-list">
          <ul>
            <li class="current"><a href="#" title="ENTRADAS">ENTRADAS</a>/</li>
            <li><a href="#" title="HORARIOS">HORARIOS</a>/</li>
            <li><a href="#" title="MOTIVOS">MOTIVOS</a>/</li>
            <li><a href="#" title="PROCEDENCIA">PROCEDENCIA</a>/</li>
            <li><a href="#" title="PROMOCIONES">PROMOCIONES</a></li>
          </ul>
        </nav>

        <fieldset>
          <div class="ticket-info">
            <div class="inputControl calendar">
              <input type="text" value="28/11/2019">
              <img class="svg" src="./img/icon-calendar.svg" alt="icono calendar">
            </div>
            <div class="inputControl">
              <input class="cliente" type="text" placeholder="Cliente">
              <img class="svg" src="./img/icon-search.svg" alt="icono cliente">
            </div>
          </div>

          <div class="wrap-tabs-seleccion">
            <div class="tabs-seleccion">
              <ul>
                <li><a href="#tabSel-01">Nombre Categoría</a></li>
                <li><a href="#tabSel-02">Nombre Categoría</a></li>
                <li><a href="#tabSel-03">Entradas con promoción para el verano 4 líneas...</a></li>
                <li><a href="#tabSel-04">Nombre Categoría</a></li>
                <li><a href="#tabSel-05">Nombre Categoría</a></li>
                <li><a href="#tabSel-06">Entradas con promoción</a></li>
                <li><a href="#tabSel-07">Nombre Categoría</a></li>
                <li><a href="#tabSel-01">Nombre Categoría</a></li>
                <li><a href="#tabSel-02">Nombre Categoría</a></li>
                <li><a href="#tabSel-03">Entradas con promoción para el verano 4 líneas...</a></li>
                <li><a href="#tabSel-04">Nombre Categoría</a></li>
                <li><a href="#tabSel-05">Nombre Categoría</a></li>
                <li><a href="#tabSel-06">Entradas con promoción</a></li>
                <li><a href="#tabSel-07">Nombre Categoría</a></li>
              </ul>
            </div>
            <div id="tabs-content">
              <div id="tabSel-01">

                <div class="Rtable">
                  <div class="Rtable-row Rtable-row--head">
                    <div class="Rtable-cell item-cell column-heading">ítem</div>
                    <div class="Rtable-cell precio-cell column-heading">Precio</div>
                    <div class="Rtable-cell cantidad-cell column-heading">Cantidad</div>
                  </div>

                  <div class="listado">

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Entrada Seleccionada</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Rtable-row">
                      <div class="Rtable-cell item-cell">
                        <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                      </div>
                      <div class="Rtable-cell precio-cell">
                        <div class="Rtable-cell--content precio-content">28,00 €</div>
                      </div>
                      <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                        <div class="Rtable-cell--content cantidad-content">
                          <div class="quantity">
                            <button type="button" value="-" class="addValueButton minus">-</button>
                            <input type="number" class="qty text" step="1" min="0" name="quantity" value="0" title="Cantidad" size="4">
                            <button type="button" value="+" class="addValueButton plus">+</button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <ul class="pagination">
                  <li>
                    <a href="#" title="Previo">
                      <img class="svg" src="./img/active-arrow.svg" alt="Previo">
                    </a>
                  </li>
                  <li><a href="#">1</a></li>
                  <li><a href="#">2</a></li>
                  <li><a href="#">3</a></li>
                  <li><a href="#">4</a></li>
                  <li><a class="active" href="#">5</a></li>
                  <li><a href="#">6</a></li>
                  <li>
                    <a href="#" title="Próximo">
                      <img class="svg" src="./img/active-arrow.svg" alt="Próximo">
                    </a>
                  </li>
                </ul>

              </div>
              <div id="tabSel-02">
                CAT 0222222222222222222
              </div>
              <div id="tabSel-03">
                CAT 03333333333
              </div>
              <div id="tabSel-04">
                CAT 044444444
              </div>
              <div id="tabSel-05">
                CAT 0555555555
              </div>
              <div id="tabSel-06">
                CAT 066666666666666
              </div>
              <div id="tabSel-07">
                CAT 07777777777777
              </div>
            </div>
          </div>

        </fieldset>

        <div class="btn-continuar-wrap">
          <a class="SiguienteButton" href="#" title="Siguiente">Siguiente</a>
        </div>

      </section>
      <section class="col-resumen">
        <div class="cliente-fecha">
          <span>Nombre Corto Cliente - 20% - 90 días</span>
          <span>Viernes 28, Noviembre 2019.</span>
          <span>Tercera linea Recinto: 11:00h.</span>
          <span>Cuarta linea cortada para seguir mas lineas</span>
        </div>
        <fieldset>
          <div class="white-box">
            <div class="Rtable">
              <div class="Rtable-row Rtable-row--head">
                <div class="Rtable-row-inner">
                  <div class="Rtable-cell item-cell column-heading">ítem</div>
                  <div class="Rtable-cell cantidad-cell column-heading">Cant.</div>
                  <div class="Rtable-cell precio-cell column-heading">total</div>
                  <div class="Rtable-cell delete-cell column-heading"></div>
                </div>
              </div>

              <div class="detailScroll">

                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="14" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">392,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="2" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">56,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="14" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">140,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto Simulado texto muy largo de varias
                        lineas</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="2" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">56,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="14" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">392,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="2" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">56,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto Simulado</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="14" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">140,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Rtable-row">
                  <div class="Rtable-row-inner">
                    <div class="Rtable-cell item-cell">
                      <div class="Rtable-cell--content item-content">Nombre Producto Simulado texto muy largo de varias
                        lineas</div>
                    </div>
                    <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                      <div class="Rtable-cell--content cantidad-content">
                        <div class="quantity">
                          <input type="number" class="qty text" step="1" min="0" name="quantity" value="2" title="Cantidad" size="4">
                        </div>
                      </div>
                    </div>
                    <div class="Rtable-cell precio-cell">
                      <div class="Rtable-cell--content precio-content">56,00 €</div>
                    </div>
                    <div class="Rtable-cell delete-cell">
                      <div class="Rtable-cell--content delete-content">
                        <a href="#" title="Borrar">
                          <span class="cross"></span>
                          <span class="sr-only">cerrar</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </fieldset>


        <div class="NumpadWrap">
          <div class="totales">
            <div class="titulos">
              <span>cantidad</span>
              <span>total</span>
            </div>
            <div class="numeros">
              <span>23</span>
              <span>644,00 €</span>
            </div>
          </div>
          <div class="Numpad">
            <div class="calculator">
              <div class="keys">7</div>
              <div class="keys">8</div>
              <div class="keys">9</div>
              <div class="keys darker">
                <img class="svg" src="./img/numpad-back.svg" alt="icono back">
              </div>
              <div class="keys">4</div>
              <div class="keys">5</div>
              <div class="keys">6</div>
              <div class="keys darker">
                <img class="svg" src="./img/numpad-x.svg" alt="icono x">
              </div>
              <div class="anomaly-keys-wrapper">
                <div>
                  <div class="keys">1</div>
                  <div class="keys">2</div>
                  <div class="keys">3</div>
                  <div class="keys long">0</div>
                  <div class="keys">,</div>
                </div>
                <div>
                  <div class="keys tall darker">
                    <img class="svg" src="./img/numpad-enter.svg" alt="icono enter">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button type="button" value="PAGAR" class="pagar">PAGAR</button>
        </div>


      </section>
    </div>
  </form>

</div>


<div class="backModal enCalendar">
  <div class="close closeModal">
    <a href="/venta/entradas" title="cerrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
  </div>
  <div class="CalendarioBox">
    <div class="tituloSearch">
      Elige la fecha
    </div>

    <div class="calendar__header">
      <div class="selectCustom calendar_select--month" title="Selecciona el mes">
        <img class="svg" src="./img/active-arrow.svg" alt="icono">
        <div class="current">Diciembre</div>
        <div class="calendar_list_month hiddenList">
          <div class="pest">
            <div class="inner">
              <i class="top left"></i>
              <i class="top right"></i>
              <div class="colorBG"></div>
            </div>
          </div>
          <div class="cols">
            <div class="col">
              <div class="calendar_link disable">Enero</div>
              <div class="calendar_link disable">Febrero</div>
              <div class="calendar_link">Marzo</div>
              <div class="calendar_link">Abril</div>
              <div class="calendar_link">Mayo</div>
              <div class="calendar_link">Junio</div>
            </div>
            <div class="col">
              <div class="calendar_link">Julio</div>
              <div class="calendar_link">Agosto</div>
              <div class="calendar_link">Septiembre</div>
              <div class="calendar_link">Octubre</div>
              <div class="calendar_link">Noviembre</div>
              <div class="calendar_link selected">Diciembre</div>
            </div>
          </div>
        </div>
      </div>
      <div class="selectCustom calendar_select--year" title="Seleccciona el año">
        <img class="svg" src="./img/active-arrow.svg" alt="icono">
        <div class="current">2019</div>
        <div class="calendar_list_day hiddenList">
          <div class="calendar_link selected">2019</div>
          <div class="calendar_link">2020</div>
          <div class="calendar_link">2021</div>
          <div class="calendar_link">2022</div>
          <div class="calendar_link">2023</div>
        </div>
      </div>
      <div class="calendar_nav--prev" data-nav="-1" role="button" title="Mes anterior">
        <img class="svg" src="./img/active-arrow.svg" alt="Previo">
      </div>
      <div class="calendar_nav--next" data-nav="1" role="button" title="Próximo mes">
        <img class="svg" src="./img/active-arrow.svg" alt="Próximo">
      </div>
    </div>

    <table class="calendar_table">
      <thead>
        <tr>
          <th class="calendar_weekday" scope="col" title="Lunes">Lun</th>
          <th class="calendar_weekday" scope="col" title="Martes">Mar</th>
          <th class="calendar_weekday" scope="col" title="Miércoles">Mie</th>
          <th class="calendar_weekday" scope="col" title="Jueves">Jue</th>
          <th class="calendar_weekday" scope="col" title="Viernes">Vie</th>
          <th class="calendar_weekday" scope="col" title="Sábado">Sab</th>
          <th class="calendar_weekday" scope="col" title="Domingo">Dom</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="25 Noviembre, 2019">25</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="26 Noviembre, 2019">26</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="27 Noviembre, 2019">27</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="28 Noviembre, 2019">28</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="29 Noviembre, 2019">29</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="30 Noviembre, 2019">30</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="1 Diciembre, 2019">1</div>
          </td>
        </tr>
        <tr>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="2 Diciembre, 2019">2</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="3 Diciembre, 2019">3</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="4 Diciembre, 2019">4</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="5 Diciembre, 2019">5</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="6 Diciembre, 2019">6</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="7 Diciembre, 2019">7</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="8 Diciembre, 2019">8</div>
          </td>
        </tr>
        <tr>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="9 Diciembre, 2019">9</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="10 Diciembre, 2019">10</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="11 Diciembre, 2019">11</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus calendar_day--highlighted" aria-label="12 Diciembre, 2019">12</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="13 Diciembre, 2019">13</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="14 Diciembre, 2019">14</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="15 Diciembre, 2019">15</div>
          </td>
        </tr>
        <tr>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="16 Diciembre, 2019">16</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="17 Diciembre, 2019">17</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="18 Diciembre, 2019">18</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="19 Diciembre, 2019">19</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="20 Diciembre, 2019">20</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="21 Diciembre, 2019">21</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="22 Diciembre, 2019">22</div>
          </td>
        </tr>
        <tr>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="23 Diciembre, 2019">23</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="24 Diciembre, 2019">24</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="25 Diciembre, 2019">25</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="26 Diciembre, 2019">26</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="27 Diciembre, 2019">27</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="28 Diciembre, 2019">28</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="29 Diciembre, 2019">29</div>
          </td>
        </tr>
        <tr>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="30 Diciembre, 2019">30</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--infocus" aria-label="31 Diciembre, 2019">31</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="1 Enero, 2020">1</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="2 Enero, 2020">2</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="3 Enero, 2020">3</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="4 Enero, 2020">4</div>
          </td>
          <td role="presentation">
            <div class="calendar_day calendar_day--outfocus" aria-label="5 Enero, 2020">5</div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>



</div>



  <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js"></script>
<script src="./js/all.js"></script>

</body>
</html>
